<div class="user-container">
  <img [src]=" data.candidature.candidatePhoto ? data.candidature.candidatePhoto : '/assets/icons/no-pic.svg'" class="img size-sm"
       alt="user_img">
  <div>
    <div class="fs-13 fw-4" [matTooltip]="data.candidature.candidateName">{{ textSubstring(data.candidature.candidateName, 20 )}}</div>
<!--    <div class="fs-11 fw-4 text-neutral-dark-grey" [matTooltip]="data.mailadress">{{ textSubstring(data.mailadress, 20 )}}</div>-->
  </div>
</div>
